import React, { FC, useCallback } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { object, string } from 'yup';
import { ApiErrorCont, Form, Link, InputCont } from './SignInForm.styles';
import { RouteNames } from '../../constans/routes';
import { ILoginRequest } from '../../services/auth';
import Input from '../Input/Input';
import Notification from '../Notification/Notification';
import SubmitButton from '../SubmitButton/SubmitButton';

interface ISignInForm {
  submitForm: (data: ILoginRequest) => void;
  apiError?: {
    title: string | null;
    description: string | null;
  };
}
const SignInForm: FC<ISignInForm> = ({ submitForm, apiError }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const signInSchema = object({
    email: string()
      .email(t('login.signIn.emailMustBeAValidEmail'))
      .required(t('login.signIn.emailIsRequired')),
    password: string().required(t('login.signIn.passwordIsRequired')),
  });
  const formMethods = useForm({
    defaultValues: {
      email: '',
      password: '',
    },
    resolver: yupResolver(signInSchema),
  });
  const { handleSubmit } = formMethods;

  const resetPassword = useCallback(() => navigate(RouteNames.PasswordReset), [navigate]);

  const message = {
    mode: 'error',
    type: 'static',
    title: apiError?.title || 'error',
    description: apiError?.description || 'error',
  };

  return (
    <FormProvider {...formMethods}>
      <Form onSubmit={handleSubmit(submitForm)}>
        <InputCont>
          <Input
            label={t('login.signIn.email')}
            registerPath={'email'}
            placeholder={t('login.signIn.yourEmailAddress')}
          />
          <Input
            label={t('login.signIn.password')}
            registerPath={'password'}
            placeholder={t('login.signIn.yourPassword')}
            type="password"
          />
          <Link data-testid="forgot-password-link" onClick={resetPassword}>
            {t('login.signIn.forgotPassword')}
          </Link>
        </InputCont>
        {apiError?.description && (
          <ApiErrorCont>
            <Notification data={message} />
          </ApiErrorCont>
        )}
        <SubmitButton text={t('login.signIn.login')} />
      </Form>
    </FormProvider>
  );
};

export default SignInForm;
